<template>
    <v-app class="vapp" style="margin-top: 105px">
        <CalendarToolBar v-on:change-page="onChangePage" :loading="loading" v-on:changePhantom="onChangePhantom">
        </CalendarToolBar>
        <div class="d-flex fixed-max-height">
            <div class="horizontal-scroll">
                    <v-overlay v-if="loading > 0" :value="true" absolute class="calendar-overlay">
                        <v-progress-circular style="position: fixed; left: 50%" indeterminate size="64"
                            color="secondary"></v-progress-circular>
                    </v-overlay>
                    <v-sheet class="my-vsheet" width="100%" :min-width="calc_calendarMinWidth"
                        v-bind:class="{ calendarday: c_nbOfDay === 1 }">
                        <!-- Calendar- -->
                        <v-calendar locale="fr" ref="calendar" type="category" color="secondary" category-show-all
                            v-model="c_dateFocus" event-overlap-mode="column" :columns="[]" :first-time="c_firstTime"
                            :events="calc_event" :categories="calc_categoriesName" :interval-minutes="c_intervalMinutes"
                            :interval-count="calc_IntervalCount" :interval-height="calc_IntervalHeight"
                            :category-days="c_nbOfDay"  @mousedown:event="onMouseDownEvent"
                            @mousedown:time-category="onMouseDownColumn" @mousemove:time-category="onMouseMovColumn"
                            @mouseup:time-category="onMouseUpColumn" @mousemove:time="onHoverInterval"
                            @mouseleave:time="() => (hoverTime = null)">
                            <!-- SLOT: category name -->
                            <template v-slot:category="data">
                                <div
                                    :set="(color = c_selectedCategory === data.category && data.date === timeGetter(c_selectedTimePos, true))">
                                    <div v-if="JSON.parse(data.category).type === 'space'"
                                        class="v-calendar-category__category v-calendar-space">
                                        <v-icon color="#b1dad6">mdi-layers</v-icon>
                                        <span>{{ JSON.parse(data.category).name }}</span>
                                    </div>
                                    <div v-else class="v-calendar-category__category v-calendar-staff">
                                        <v-icon color="#4b5b6b">mdi-account</v-icon>
                                        <span>{{ JSON.parse(data.category).first_name }} {{ JSON.parse(data.category).last_name }}</span>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:interval="event">
                                <div style="width: 100%; height: 100%"
                                    v-bind:class="{ hover_grey: hoverTime && `${event.date} ${event.time}` === timeGetterAround(hoverTime) }">
                                    <div style="width: 100%; height: 100%; text-align: center" v-bind:class="{
                                        'colored-case': c_selectedTimePos && `${event.date} ${event.time}` === timeGetter(c_selectedTimePos),
                                        'force-color':
                                            c_showModal &&
                                            c_selectedTimePos &&
                                            `${event.date} ${event.time}` === timeGetter(c_selectedTimePos) &&
                                            calc_categoriesName?.length === 0,
                                    }">
                                        <span 
                                            style="color: #8d8c8c; 
                                            display: block"
                                            v-if="hoverTime && `${event.date} ${event.time}` === timeGetterAround(hoverTime)">
                                            {{ event.time }}
                                        </span>
                                    </div>
                                </div>
                            </template>

                            <!-- SLOT: 1 day header -->
                            <template v-if="c_nbOfDay == 1" v-slot:day-label-header="{}">
                                <!-- <div v-for="(week, index) in getWeekDays()" 
                                    :key="index"
                                    style="flex:1; color:#555;">
                                    Semaine {{ week.week }}
                                </div> -->
                                <div></div>
                            </template>

                            <!-- SLOT: timeslots -->
                            <template v-slot:event="{ event }">
                                <CustomTimeslot :event="event"></CustomTimeslot>
                            </template>

                            <!-- SLOT: current time line -->
                            <template v-slot:day-body="{ date, week }">
                                <div class="v-current-time" :class="{ first: date === week[0].date }"
                                    :style="{ top: `${calc_currentTimePos}%`, display: calc_showCurrentTimeCursor }"></div>
                            </template>
                            <!-- <template v-slot:category-header="{ category, date }">
                                <div v-if="c_nbOfDay > 1"
                                    style="text-align:center; font-weight:bold; padding:4px 0; color:#555;">
                                    Semaine {{ moment(date).week() }}
                                </div>

                                <div style="text-align:center;">
                                    {{ JSON.parse(category).name || JSON.parse(category).first_name }}
                                </div>
                            </template> -->
                        </v-calendar>
                    </v-sheet>
            </div>

            <!-- Modal -->
            <div v-if="!c_modalMobile && c_showModal"
                :class="{
                    'calendar-border calendar-modal': true,
                    'calendar-modal--add': isCalendarAddModal,
                    'calendar-modal--view': isCalendarViewModal,
                    'calendar-modal--smart': c_smartResa,
                    'minimized-modal': minimized,
                    'hide-scale': minimized
                }">
                <div class="small-menu">
                    <v-btn icon class="bg-white" @click="() => {
                        minimized = !minimized;
                    }">
                        <v-icon v-if="!this.minimized" class="text-black"> mdi-window-minimize</v-icon>
                        <v-icon v-else class="text-black"> mdi-window-maximize</v-icon>
                    </v-btn>
                    <v-btn icon class="bg-success" @click="(refreshModal = true)"
                        style="background-color: green !important;">
                        <v-icon class="text-white"> mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn icon class="bg-danger" @click="(c_showModal = false)">
                        <v-icon class="text-white"> mdi-close</v-icon>
                    </v-btn>
                </div>

                <template v-if="!c_smartResa">
                    <CalendarModalAdd2 v-if="!c_selectedEvent || c_selectedEvent.config.draft"
                        v-on:hover-off="() => (disableHover = true)" v-on:refresh="handledReloadCalendarTimeSlot"
                        v-on:clearSmartResa="() => (chooseAdd = null)" :chooseAdd="chooseAdd"></CalendarModalAdd2>
                    <CalendarModalView :refreshModal="refreshModal" :selectAll="selectAll"
                        v-on:update-info="updateInfo" v-on:select-all="changeSelectAll(true)"
                        v-on:unselect-all="changeSelectAll(false)" v-on:refresh="handledReloadCalendarTimeSlot"
                        v-on:data-refreshed="(() => { this.refreshModal = false })" buttonColormail="#8189AD"
                        buttonColorsms="#8189AD" v-else></CalendarModalView>
                </template>
                <template v-else>
                    <CalendarModalSmartResa v-on:choose="chooseAddTrigger" :startEsta="this.c_firstTime"
                        :endEsta="this.c_lastTime"></CalendarModalSmartResa>
                </template>
            </div>
        </div>

        <!-- Drawer -->
        <v-navigation-drawer v-if="c_modalMobile && c_showModal" right absolute permanent v-model="c_showModal"
            :class="{ 'calendar-border calendar-modal': true, 'minimized-modal': minimized }">
            <v-app>
                <template v-if="!c_smartResa">
                    <CalendarModalAdd2 v-if="!c_selectedEvent || c_selectedEvent.config.draft"
                        v-on:hover-off="() => (disableHover = true)" v-on:refresh="handledReloadCalendarTimeSlot"
                        :chooseAdd="chooseAdd" v-on:clearSmartResa="() => (chooseAdd = null)"></CalendarModalAdd2>
                    <CalendarModalView :selectAll="selectAll" v-on:update-info="reloadCalendarTimeSlot"
                        v-on:select-all="changeSelectAll(true)" v-on:unselect-all="changeSelectAll(false)"
                        buttonColormail="#8189AD" buttonColorsms="#8189AD" v-else></CalendarModalView>
                </template>
                <template v-else>
                    <CalendarModalSmartResa v-on:choose="chooseAddTrigger" :startEsta="this.c_firstTime"
                        :endEsta="this.c_lastTime"></CalendarModalSmartResa>
                </template>
            </v-app>
        </v-navigation-drawer>
    </v-app>
</template>

<script>
import ApiManager from './_core/ApiManager'
import InitManager from './_core/InitManager'
import TimeSlotManager from './_core/TimeSlotManager'
import {
    sync,
    get
} from 'vuex-pathify'
import qs from 'qs'
import moment from 'moment'

export default {
    name: 'calendar-custom',

    components: {
        CalendarToolBar: () => import('./ToolBar/ToolBar.vue'),
        CustomTimeslot: () => import('./Timeslot/Timeslot.vue'),
        CalendarModalAdd2: () => import('./Modal/ModalAdd.vue'),
        CalendarModalView: () => import('./Modal/ModalView.vue'),
        CalendarModalSmartResa: () => import('./Modal/ModalSmartResa.vue'),
    },

    data: () => ({
        currentWindow: {
            height: 0,
            width: 0,
        },
        modalLoading: false,
        hoverTime: 0,
        hoverCategory: null,
        loading: 0,
        mousePress: false,
        lockMove: true,
        disableHover: true,
        disableHoverDate: Date.now(),
        lastStaffs: null,
        lastSpaces: null,
        protectCall: false,
        protectCall2: Date.now(),
        chooseAdd: null,
        nowTime: moment(),
        nowTimeInterval: null,
        lastDateFocus: null,
        phantom: false,
        minimized: false,
        diffTime: 0,
        selectAll: false,
        moved: false,
        refreshModal: false
    }),

    created() {
        this.c_calendar = InitManager.createInitialCalendarState()
        this.c_dateFocus = localStorage.getItem('date-focus') || moment(new Date()).format('YYYY-MM-DD')

        // == Auto resize == //
        globalThis.window.addEventListener('resize', this.handleResize)
        globalThis.window.addEventListener('mouseup', this.handleMouseUp)
        this.handleResize()

        // == Params == //
        this.c_query = !window.location.search ? {} : qs.parse(window.location.search.replace('?', ''))
        if (this.c_query.date) this.c_dateFocus = moment(parseInt(this.c_query.date) * 1000).format('YYYY-MM-DD')
        if (this.c_query.modaladd || this.c_query.rebooking) this.c_showModal = true

        this.nowTimeInterval = setInterval(() => {
            this.nowTime = moment()
        }, 1000 * 60)
    },

    async mounted() {
        const srcElem = globalThis.document.getElementsByClassName('horizontal-scroll')[0]
        const destElem = globalThis.document.getElementsByClassName('v-calendar-daily__intervals-body')[0]
        const destHeader = globalThis.document.getElementsByClassName('v-calendar-daily__intervals-head')[0]
        srcElem.onscroll = () => {
            destElem.style.left = `${srcElem.scrollLeft - 1}px`
            destHeader.style.left = `${srcElem.scrollLeft - 1}px`
        }

        // == Data == //
        this.loading += 2
        await ApiManager.getStaffs()
            .then((res) => (this.c_staffs = res))
            .finally(() => (this.loading -= 1))
        await ApiManager.getSpaces()
            .then((res) => (this.c_spaces = res))
            .finally(() => (this.loading -= 1))

        this.c_presets = await ApiManager.getPresets()
        await ApiManager.getCalendarSettings().then((settings) => {
            if (settings && settings.firstTime && settings.lastTime) {
                this.c_firstTime = settings.firstTime
                this.c_lastTime = settings.lastTime
                this.c_calendarTimeRangeLocked = true
            }

            if (settings && settings.intervalMinutes) {
                this.c_timeIntervalMinutes = parseInt(settings.intervalMinutes)
            }
        })
        this.c_selectedPresetName = localStorage.getItem('preset')

        if (this.c_query.date && this.c_query.timeslot) {
            await this.loadTargetedTimeslot()
        }
    },

    beforeDestroy() {
        globalThis.window.removeEventListener('resize', this.handleResize)
        globalThis.window.removeEventListener('mouseup', this.handleMouseUp)
    },

    destroyed() {
        if (this.nowTimeInterval) clearInterval(this.nowTimeInterval)
    },

    watch: {
        async c_selectedPresetName(val) {
            if (val === null) this.resetPreset()
            else await this.applyPreset()
        },
        async c_forceLoad(val, old) {
            if (old === undefined) return
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
        },
        async c_dateFocus(val, old) {

            if (old === undefined) return
            localStorage.setItem('date-focus', val)
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
            this.hoverCategory = null
            // cancel the merge when change date
            // We can merge only the orders present in the same day
            this.c_merge_status = false;
            this.c_merge_events = [];

        },
        async c_nbOfDay(val, old) {
            if (old === undefined) return
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
        },
        async c_selectedStaffs(val) {
            if (this.lastStaffs === null && val && val.length == 0) return

            if (JSON.stringify(val) != this.lastStaffs) {
                this.lastStaffs = JSON.stringify(val)
                this.loading += 1
                await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
            }
        },
        async c_selectedSpaces(val) {
            if (this.lastSpaces === null && val && val.length == 0) return

            if (JSON.stringify(val) != this.lastSpaces) {
                this.lastSpaces = JSON.stringify(val)
                this.loading += 1
                await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
            }
        },
        calc_columnNbr(val) {
            const srcElems = globalThis.document.getElementsByClassName('v-calendar-daily__day')
            for (const index in srcElems) {
                if (isNaN(index)) continue

                if (index % (this.c_selectedStaffs.length + this.c_selectedSpaces.length) == val) {
                    srcElems[index].classList.add('selectedCategory')
                } else srcElems[index].classList.remove('selectedCategory')
            }
        },
        calc_columnNbrHover(val) {
            const srcElems = globalThis.document.getElementsByClassName('v-calendar-daily__day')
            for (const index in srcElems) {
                if (isNaN(index)) continue

                if (this.c_selectedStaffs.length + this.c_selectedSpaces.length === 0) {
                    srcElems[index].classList.remove('selectedCategoryHover')
                } else if (index % (this.c_selectedStaffs.length + this.c_selectedSpaces.length) !== val) {
                    srcElems[index].classList.add('selectedCategoryHover')
                } else srcElems[index].classList.remove('selectedCategoryHover')
            }
        },

        diffTime() {
            if (this.selectAll)
                this.DragAllRelated()
            this.diffTime = 0
        }
    },

    computed: {
        c_calendar: sync('calendar'),
        ...sync('calendar@data', {
            c_staffs: 'staffs',
            c_spaces: 'spaces',
            c_events: 'events',
            c_hideEvents: 'hideEvents',
            c_hideStaffs: 'hideStaffs',
            c_counterConsecColumn: 'counter',
            c_presets: 'presets',
        }),
        ...sync('calendar@params', {
            c_dateFocus: 'dateFocus',
            c_showModal: 'showModal',
            c_miniToolBar: 'miniToolBar',
            c_smartResa: 'smartResa',
            c_query: 'query',
            c_reopentTimeslot: 'openTimeslot',
            c_lastTime: 'lastTime',
            c_firstTime: 'firstTime',
            c_calendarTimeRangeLocked: 'calendarTimeRangeLocked',
            c_nbOfDay: 'nbOfDay',
            c_slideValueY: 'intervalYLevel',
            c_timeIntervalMinutes: 'intervalMinutes',
        }),
        ...get('calendar@params', {
            c_intervalMinutes: 'intervalMinutes',
            c_intervalYLevel: 'intervalYLevel',
            c_modalMobile: 'modalMobile',
            newLogin: 'newLogin',
        }),
        ...sync('calendar@selected', {
            c_selectedStaffs: 'staffs',
            c_selectedSpaces: 'spaces',
            c_forceLoad: 'load',
            c_search: 'search',
            c_selectedPresetName: 'preset',
            c_editEvents: 'editEvents'
        }),
        ...sync('calendar@selected', {
            c_selectedCategory: 'category',
            c_selectedEvent: 'event',
            c_selectedTimePos: 'mouseTime',
        }),
        ...sync('calendar@move', {
            c_move_id: 'move_id',
            c_move_start: 'move_start',
            c_move_end: 'move_end',
            c_move_event: 'move_event',
            c_move_drag: 'move_drag',
            c_duration: 'move_duration',
            c_move_date: 'move_date',
        }),
        ...sync('calendar@merge', {
            c_merge_status: 'status',
            c_merge_events: 'events',
        }),
        isCalendarAddModal() {
            return !this.c_smartResa && (!this.c_selectedEvent || this.c_selectedEvent.config.draft)
        },
        isCalendarViewModal() {
            return !this.c_smartResa && this.c_selectedEvent && !this.c_selectedEvent.config.draft
        },
        calc_event() {
            return !this.c_search ?
                this.c_events :
                this.c_events.filter((x) => {
                    return (
                        x.config.block || (x.data && x.data.client && x.data.client.toLowerCase().includes(this.c_search.toLowerCase()) || (x.data && x.data.prestation && x.data.prestation.name.toLowerCase().includes(this.c_search.toLowerCase())))
                    )
                })
        },

        calc_columnNbr() {
            if (!this.lockMove || this.disableHover || !this.c_showModal) return -1
            if (this.c_selectedCategory) {
                const index = this.calc_categoriesName.findIndex((x) => x == this.c_selectedCategory)
                return index
            }
            return -1
        },
        calc_columnNbrHover() {
            if (!this.hoverCategory) return -1
            const index = this.calc_categoriesName.findIndex((x) => x == this.hoverCategory)
            return index
        },

        calc_calendarMinWidth() {
            return '100%'
        },

        // Used with c_intervalYLevel to expend/compact height cell
        calc_IntervalHeight() {
            return `${(this.currentWindow.height - 280) / this.calc_IntervalCount +
                5 * ((this.c_intervalYLevel > 5 ? this.c_intervalYLevel * 4 : this.c_intervalYLevel) * 2)
                }px`
        },

        // Compute minutes between interval [first time <-> last time]
        calc_calendarDayMinutes() {
            const start = moment(this.c_firstTime, 'HH:mm')
            const end = moment(this.c_lastTime, 'HH:mm')
            return moment.duration(end.diff(start)).asMinutes()
        },

        // Compute the nb of needed interval
        calc_IntervalCount() {
            return this.calc_calendarDayMinutes / this.c_intervalMinutes
        },

        // Generate all calendar column name's
        calc_categoriesName() {
            return this.c_selectedStaffs
                .filter(
                    (x) =>
                        !this.c_hideStaffs.find((y) => y.id === x.id && y.count === 0 && !x.tmp) ||
                        this.c_events.find((e) => !e.config.block && e.category === x.stringify)
                )
                .map((x) => x.stringify)
                .concat(this.c_selectedSpaces.map((x) => x.stringify))
        },

        // Used to display current time curssor
        calc_currentTimePos() {
            const start = moment(this.c_firstTime, 'HH:mm')
            const now = this.nowTime
            const tt = this.calc_calendarDayMinutes
            return (moment.duration(now.diff(start)).asMinutes() * 100) / tt
        },

        // Is today ?
        calc_showCurrentTimeCursor() {
            return this.c_dateFocus === moment().format('YYYY-MM-DD') ? 'relative' : 'none'
        },
    },

    methods: {
        updateInfo()
        {
            this.c_move_event = []
            this.c_move_staff = {}
            this.changeSelectAll(false)
            this.reloadCalendarTimeSlot()
        },
        refreshAutoSizeColumn() {
    // headers
    const headDays = document.querySelectorAll('.v-calendar-daily_head-day .v-calendar-category__columns')
    headDays.forEach((dayColumns) => {
        Array.from(dayColumns.children).forEach((element, index) => {
            const target = this.calc_categoriesName[index]
            if (!target) return
            const flex = this.c_counterConsecColumn[target] ?? 1
            element.setAttribute('style', `flex: ${flex < 1 ? 1 : flex} !important`)
        })
    })

    // body
    const res = document.querySelector('.v-calendar-daily__day-container')
    if (!res) return

    const nbCategories = this.calc_categoriesName.length
    if (nbCategories === 0) return

    Array.from(res.children).forEach((element, index) => {
        if (index === 0) return // intervals-body

        // En vue multi-jours : index 1..N*nbDays
        // La catégorie correspondante = (index - 1) % nbCategories
        const catIndex = (index - 1) % nbCategories
        const target = this.calc_categoriesName[catIndex]
        if (!target) return

        const flex = this.c_counterConsecColumn[target] ?? 1
        element.setAttribute('style', `flex: ${flex < 1 ? 1 : flex} !important`)
    })
},

        timeGetter(date, onlyDate = false) {
            return moment(date).format(onlyDate ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm')
        },

        chooseAddTrigger(params) {
            this.chooseAdd = params
            this.c_selectedEvent = null
            this.c_smartResa = false
            this.c_showModal = true
        },

        timeGetterAround(date) {
            const obj = moment(date)
            return obj.add(-date.minutes() % this.c_intervalMinutes, 'minutes').format('YYYY-MM-DD HH:mm')
        },

        isTmp(cat) {
            if (cat.type === 'staff') {
                return this.c_selectedStaffs.find((x) => x.id === cat.id && x.tmp) != null
            } else {
                return this.c_selectedSpaces.find((x) => x.id === cat.id && x.tmp) != null
            }
        },

        async handledReloadCalendarTimeSlot() {
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
        },

        handleResize() {
            this.currentWindow.height = globalThis.window.innerHeight
            this.currentWindow.width = globalThis.window.innerWidth
            if (this.currentWindow.width < 958 && !this.c_miniToolBar) this.c_miniToolBar = true
            if (this.currentWindow.width >= 958 && this.c_miniToolBar) this.c_miniToolBar = false
        },

        handleMouseUp() {
            this.lockMove = true
        },
        changeSelectAll(value) {
            this.selectAll = value;
            value ?
                this.c_events.forEach(z => {
                    if (z.id == this.c_selectedEvent.id) z.config.movable = true
                }) :
                this.handledReloadCalendarTimeSlot()

        },
        // == Events == //
        async onChangePage(next) {
            if (next) this.$refs.calendar.next()
            else this.$refs.calendar.prev()
        },
        async onChangePhantom(dataphantom) {
            this.phantom = true;
            this.reloadCalendarTimeSlot();
        },

        onHoverInterval(context) {
            this.hoverTime = moment(`${context.date} ${context.time}:00`)
        },

        // Click on timeslot
        onMouseDownEvent(context) {
            if (!context.event.config.draft && this.c_events.find((x) => x.config.draft)) return

            if (context.event.category && !context.event.config.draft) {
                const wanted = JSON.parse(context.event.category)
                const target =
                    this.c_selectedSpaces.find((y) => y.id == wanted.id) || this.c_selectedStaffs.find((y) => y.id == wanted.id)
                if (target.tmp) target.tmp = false
            }

            this.c_selectedEvent = context.event
            this.disableHover = true
            // Secure time
            this.disableHoverDate = Date.now() + 500

            // Merge orders
            if (this.c_merge_status) {
                // console.log("context.event", context.event)

                const check = this.c_merge_events.find((x) => x.order_id == context.event.data.order_id)
                // Check if the item not already added to the merege list and doesn't closed (status = 7 in the DB)
                // Please not in front-end we are using the value 6 for closed CMD.
                if (!check && context.event.data.status != 6) {
                    let duplicates = {}
                    let relatedItems = Object.create(this.c_events.filter((x) => { return x.data.order_id == context.event.data.order_id }).filter((item) => {
                        if (!duplicates[item.id]) {
                            duplicates[item.id] = true;
                            return true;
                        }
                        return false;
                    }))
                    relatedItems.sort((x, y) => x.start - y.start)
                    this.c_merge_events[1] = { order_id: context.event.data.order_id, booking_id: context.event.data.bookingId, name: context.event.data.prestation.name, timeslot_id: context.event.data.id, client: context.event.data.client, relatedItems: relatedItems };
                }
                // console.log("c_merge_events 222", this.c_merge_events)
            }
        },

        // Click on category
        onMouseDownColumn(context) {
            if (
                this.c_selectedEvent &&
                this.c_selectedEvent.config.block &&
                this.c_selectedEvent.data &&
                this.c_selectedEvent.data.priority !== 3 &&
                !this.c_selectedEvent.data.lunch
            ) {
                this.c_selectedEvent = null
                this.c_showModal = false
                return
            }

            this.c_selectedCategory = context.category
            // this.modalLoading = true
            this.c_showModal = true
            this.c_smartResa = false
            this.lockMove = false
            if (this.disableHoverDate < Date.now()) {
                this.disableHover = false
                this.c_selectedEvent = null
            }

            let cursorStart = moment(`${context.date} ${context.time}:00`)
            const remainder = -(cursorStart.minute() % this.c_intervalMinutes)
            cursorStart = cursorStart.add(remainder, 'minutes').valueOf()

            this.c_selectedTimePos = cursorStart
        },

        onMouseMovColumn(context) {
            if (this.c_selectedEvent?.config.movable && this.c_move_drag) {
                const eventDate = new Date(this.c_selectedEvent.start);
                const mouseTime = new Date(eventDate.toDateString() + ' ' + context.time).getTime();
                let diff = 0;
                if (mouseTime - this.c_selectedEvent.start >= 300000) {
                    this.moveReal(context, this.c_selectedEvent.start, mouseTime);
                    let allEvent = this.c_events.filter(ev => ev.data.order_id == this.c_selectedEvent.data.order_id && ev.id != this.c_selectedEvent.id && ev.start > this.c_selectedEvent.start);
                    // console.log('allEvent',allEvent)
                    allEvent.length > 0
                    {
                        let previous = allEvent[0];
                        let changed = false
                        if (this.c_selectedEvent.end >= allEvent[0].start) {
                            this.moved = true;

                            allEvent.forEach((e, index) => {
                                if (allEvent[index].id != previous.id) {
                                    previous = allEvent[index - 1]
                                    changed = true
                                }
                                const diff = e.end - e.start
                                changed && e.id != allEvent[0].id ? e.start = previous.end : e.start = this.c_selectedEvent.end
                                e.end = e.start + diff

                            })
                        } else {
                            if (this.moved)
                                allEvent.forEach((e, index) => {
                                    if (allEvent[index].id != previous.id) {
                                        previous = allEvent[index - 1]
                                        changed = true
                                    }
                                    const diff = e.end - e.start
                                    changed && e.id != allEvent[0].id ? e.start = previous.end : e.start = this.c_selectedEvent.end
                                    e.end = e.start + diff
                                })
                        }
                    }
                }
            } else {
                this.hoverCategory = context.category
                if (this.lockMove || !this.c_selectedEvent || !this.c_selectedEvent.config.movable) return

                let collision = null
                let leave = false
                const newDate = moment(`${context.date} ${context.time}:00`).add(-10, 'minutes')
                newDate.add(-newDate.minutes() % 5, 'minutes')
                let newStart = newDate.valueOf()
                let newEnd = this.c_selectedEvent.end + (newStart - this.c_selectedEvent.start)

                const parent = this.c_selectedEvent.parent ? this.c_selectedEvent.parent : this.c_selectedEvent
                if (
                    this.c_selectedEvent.config.draft &&
                    !this.c_selectedEvent.isIndispo &&
                    context.category != this.c_selectedEvent.category &&
                    this.c_nbOfDay === 1
                ) {
                    const contextCat = JSON.parse(context.category)
                    const eventCat = JSON.parse(this.c_selectedEvent.category)
                    if (contextCat.type != eventCat.type) return

                    if (!parent.list.find((x) => x.category === context.category)) {
                        if (contextCat.type === 'staff') {
                            parent.ref_presta.selectedPracticienne = parent.ref_presta.selectedPracticienne.filter((x) => x.id !== eventCat.id)
                            parent.ref_presta.selectedPracticienne.push(contextCat)
                        } else {
                            parent.ref_presta.selectedSpace = contextCat
                        }
                        this.c_selectedEvent.category = context.category
                    }
                }


                this.c_events.forEach((y) => {
                    this.c_events
                        .filter((x) => x.config.draft)
                        .forEach((i) => {
                            if (
                                i.category != y.category ||
                                i.id == y.id ||
                                (this.c_selectedEvent.parent || this.c_selectedEvent).id != (i.parent || i).id
                            )
                                return

                            var date1 = [moment(newStart), moment(newEnd)]
                            var date2 = [moment(y.start), moment(y.end)]

                            var range = moment.range(date1)
                            var range2 = moment.range(date2)

                            if (range.overlaps(range2)) {
                                collision = y
                            }
                        })
                })

                if (collision && !this.c_selectedEvent.isIndispo) {
                    if (newStart - collision.start < collision.end - newStart) {
                        // TP en haut
                        newStart = collision.start - (this.c_selectedEvent.end - this.c_selectedEvent.start)
                        newEnd = this.c_selectedEvent.end + (newStart - this.c_selectedEvent.start)
                    } else {
                        // Tp en bas
                        newStart = collision.end
                        newEnd = this.c_selectedEvent.end + (newStart - this.c_selectedEvent.start)
                    }
                }

                this.c_events.forEach((y) => {
                    this.c_events
                        .filter((x) => x.config.draft)
                        .forEach((i) => {
                            if (
                                i.category != y.category ||
                                i.id == y.id ||
                                (this.c_selectedEvent.parent || this.c_selectedEvent).id != (i.parent || i).id
                            )
                                return
                            var date1 = [moment(newStart), moment(newEnd)]
                            var date2 = [moment(y.start), moment(y.end)]

                            var range = moment.range(date1)
                            var range2 = moment.range(date2)

                            if (range.overlaps(range2)) {
                                leave = true
                            }
                        })
                })
                if (leave) return

                // Real Cards
                if (!this.c_selectedEvent.config.draft && !this.c_selectedEvent.config.block) {
                    this.moveReal(context, newStart, newEnd)
                    return
                }

                if (this.c_selectedEvent.config.block) {
                    Object.assign(parent, {
                        start: newStart,
                        end: newEnd
                    })
                    return
                }

                // Draft Cards
                Object.assign(parent.ref_presta, {
                    start: newStart,
                    end: newEnd
                })
                Object.assign(parent, {
                    start: newStart,
                    end: newEnd
                })
                parent.list.forEach((l) => {
                    Object.assign(l, {
                        start: newStart,
                        end: newEnd
                    })
                })
            }

        },

        onMouseUpColumn(context) {
            this.c_move_drag = false;
            this.moved = false;
        },

        moveReal(context, newStart, newEnd) {
            /** All event timeslots have the same Id.
             *  The idea we need to know the drag (with time ms).
             *  I used the @take to save only the first diff
            */
            let take = true;
            //  let relatedTimeslots = this.c_events.filter((x) => )
            this.c_events.forEach((e, index) => {
                if (e.id == this.c_selectedEvent.id) {
                    // console.log('eeeeeeee', e, this.c_selectedEvent)

                    if (take) {
                        this.diffTime = newStart - e.start
                        take = false
                    }
                    e.start = newStart
                    e.end = newEnd
                    this.c_duration.push({ 'id': this.c_selectedEvent.id, 'value': Math.floor((newEnd - newStart) / 1000 / 60) });
                }

            })
        },
        DragAllRelated() {
            // take all related events (timeslot) without the current one.
            let allEvent = this.c_events.filter(ev => ev.data.order_id == this.c_selectedEvent.data.order_id && ev.id != this.c_selectedEvent.id);
            allEvent.forEach((e) => {
                e.start += this.diffTime
                e.end += this.diffTime
            })
        },

        // == Data == //
        async reloadCalendarTimeSlot() {
            // Init
            const requestDate = Date.now()
            const days = this.getTargetDays()
            const staff_ids = this.c_selectedStaffs.map((x) => x.id) || []
            const space_ids = this.c_selectedSpaces.map((x) => x.id) || []
            const phantom = this.phantom
            // Load data
            const [timeslot, working, schedule] = await Promise.all([
                ApiManager.getAllTimeslotPack(days, staff_ids, space_ids, phantom),
                ApiManager.loadWorkingTime(staff_ids, space_ids, days),
                ApiManager.getEstaInfoForDays(days).catch((err) => console.log('Error:', err)),
            ])
            if (requestDate < this.protectCall2) return
            this.protectCall2 = requestDate

            // Reset all events
            this.c_events = TimeSlotManager.resetNoDraft(this.c_events)

            if (this.c_move_event) {
                this.c_move_event = TimeSlotManager.deleteDuplicate(this.c_move_event, 'category', 'data', 'id')
                this.c_move_event.forEach(element => {
                    /**
                     * This condition used to check if this element is already in calender (Current day) or not
                     * Create a couple ids between the item_id and the sttaff id
                     */
                    let condition = this.c_events.map(x => x.data.id + "-" + JSON.parse(x.category).id).includes(element.data.id + "-" + JSON.parse(element.category).id)
                    element.data.info.colorCategory = '#ff0000'
                    if (!condition)
                        this.c_events.push(element)
                });
            }
            // Get calendar time
            if (!this.c_calendarTimeRangeLocked) {
                const {
                    start,
                    end
                } = this._getBestCalendarTime(schedule)
                this.c_firstTime = start
                this.c_lastTime = end
            }

            // Generate blocks before and after establishement time
            // this._generateScheduleBlocs(schedule)
            // console.log('working',working);

            if (working) {
                // console.log('working',working);
                // Generate indispo
                this._generateIndispoBlocs(working)

                // Generate blocks before and after working time
                const done = this._generateWorkingBlocs(working)
                // Generate exception block
                this._generateExceptionBlocs(working)
                if (true) {
                    const hideEmptyColumn = this._generateMissingWorkingBlocs(days, done)
                    this.c_hideStaffs = hideEmptyColumn

                } else {
                    // Generate indispo
                    this._generateIndispoBlocs(working)

                    // Generate blocks before and after working time
                    const done = this._generateWorkingBlocs(working)
                    // Generate exception block
                    this._generateExceptionBlocs(working)
                    if (true) {
                        const hideEmptyColumn = this._generateMissingWorkingBlocs(days, done)
                        this.c_hideStaffs = hideEmptyColumn

                    } else {

                        this.closeEmptyPlaning(days);
                    }
                }

            }

            // filter exceptionnal opening
            const validEstablishmentExceptions = working?.planningsEstablishement?.filter(exc => exc.status !== -1)

            if (validEstablishmentExceptions.length  < 0) {
                /// Generate blocks before and after establishement time
                this._generateScheduleBlocs(schedule)
            }
            this.c_events = TimeSlotManager.mergeBlock(this.c_events)
            // console.log('[events] tous les events après merge:', JSON.stringify(this.c_events.map(e => ({
            //     id: e.id,
            //     config: e.config,
            //     category: e.category,
            //     start: moment(e.start).format('YYYY-MM-DD HH:mm'),
            //     end: moment(e.end).format('YYYY-MM-DD HH:mm'),
            // }))))

            // insert real timeslot
            const assoc = {}
            timeslot.forEach((day) => {
                for (const data of day.spaces) {

                    const target = this.c_spaces.find((x) => x.id == data.id)
                    if (target) TimeSlotManager.addList(this.c_events, this.c_hideEvents, data.timeslots, target.stringify, assoc)
                }
                for (const data of day.staffs) {

                    const target = this.c_staffs.find((x) => x.id == data.id)
                    if (target) TimeSlotManager.addList(this.c_events, this.c_hideEvents, data.timeslots, target.stringify, assoc)
                }
            })

            this.c_events = TimeSlotManager.mergeBlock(this.c_events, true)

            // Choose each column size
            this.c_counterConsecColumn = TimeSlotManager.computedMaxBlock(this.c_events)
            this.refreshAutoSizeColumn()

            // refresh opened timeslot ?
            if (this.c_reopentTimeslot) {
                this.c_selectedEvent = this.c_events.find((x) => x.data.bookingId === this.c_reopentTimeslot)
                this.c_reopentTimeslot = null
                await this.handledReloadCalendarTimeSlot()
            }
        },

        _getBestCalendarTime(schedule) {
            const interval = schedule.reduce((prev, current) => {
                if (!prev.start || moment(current.start, 'HH:mm').isBefore(moment(prev.start, 'HH:mm'))) {
                    prev.start = current.start;
                }

                if (!prev.end || moment(prev.end, 'HH:mm').isBefore(moment(current.end, 'HH:mm'))) {
                    prev.end = current.end;
                }

                return prev
            }, {})

            // oversize
            return {
                start: moment(interval.start || '07:00', 'HH:mm')
                    .subtract({
                        minutes: this.c_intervalMinutes * 2
                    })
                    .format('HH:mm'),
                end: moment('22:00', 'HH:mm'),
            }
        },

        _generateScheduleBlocs(res) {
            res.forEach((d) => {
                const day = moment(d.date * 1000).utc().format('YYYY-MM-DD')
                const insert = (cat, d1, d2) => {
                    TimeSlotManager.addEstablishmentBlock(
                        this.c_events,
                        moment(d1, 'YYYY-MM-DD HH:mm').valueOf(),
                        moment(d2, 'YYYY-MM-DD HH:mm').valueOf(),
                        cat.stringify
                    )
                }
                this.c_selectedStaffs.forEach((x) => {
                    insert(x, `${day} 00:00`, `${day} ${d.start}`)
                    insert(x, `${day} ${d.end}`, `${day} 23:59`)
                })
                this.c_selectedSpaces.forEach((x) => {
                    insert(x, `${day} 00:00`, `${day} ${d.start}`)
                    insert(x, `${day} ${d.end}`, `${day} 23:59`)
                })
            })
        },

        _generateIndispoBlocs(workingTime) {
            console.log('[indispo] planning.length:', workingTime.planning.length)
            console.log('[indispo] planningsException:', JSON.stringify(workingTime.planningsException))
            console.log('[indispo] planningsExceptionSpace:', JSON.stringify(workingTime.planningsExceptionSpace))
            const insert = (start, end, cat, id, name, text, recId, rec, status, text_exception) => {
                TimeSlotManager.addIndispoBlock(
                    this.c_events,
                    moment(start, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    moment(end, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    cat,
                    id,
                    name,
                    text,
                    recId,
                    rec,
                    status,
                    text_exception
                )
            }
            if (workingTime.planning.length > 0)
                workingTime.planningsException.forEach((h) =>
                    insert(
                        `${h.start}`,
                        `${h.end}`,
                        this.c_staffs.find((x) => x.id == h.user_id).stringify,
                        h.id,
                        'staff',
                        h.text,
                        h.recurence_id,
                        h.rec,
                        h.status,
                        h.nature_type
                    )
                )
            workingTime.planningsExceptionSpace.forEach((h) =>
                insert(
                    `${h.start}`,
                    `${h.end}`,
                    this.c_spaces.find((x) => x.id == h.space_id).stringify,
                    h.id,
                    'space',
                    h.text,
                    h.recurence_id,
                    h.rec
                )
            )
        },

        closeEmptyPlaning(days) {

        },

        _generateWorkingBlocs(workingTime) {
            let done = {}
            const insert = (start, end, cat, launch, id) => {
                TimeSlotManager.addWorkingTime(
                    this.c_events,
                    moment(start, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    moment(end, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    cat,
                    launch,
                    id
                )
            }

            workingTime.planning.forEach((h) => {
                const date = moment.utc(h.date, 'YYYY-MM-DD').valueOf() / 1000
                if (!done[date]) done[date] = {}
                if (done[date] && !done[date][h.user_id]) done[date][h.user_id] = true

                // start - morning block
                insert(`${h.date} 01:00:00`, `${h.date} ${h.start}`, this.c_staffs.find((x) => x.id == h.user_id).stringify)

                // launch block
                if (`${h.date} ${h.lunch_start}` !== `${h.date} ${h.lunch_end}`) {
                    insert(
                        `${h.date} ${h.lunch_start}`,
                        `${h.date} ${h.lunch_end}`,
                        this.c_staffs.find((x) => x.id == h.user_id).stringify,
                        true,
                        h.id
                    )
                }

                // end - afternoon block
                insert(`${h.date} ${h.end}`, `${h.date} 23:00:00`, this.c_staffs.find((x) => x.id == h.user_id).stringify)
            })
            return done
        },

        _generateExceptionBlocs(workingTime) {
            console.log('workingTime', workingTime)
            if (!workingTime?.planningsEstablishement) return
            const getDate = (str) => moment(str, 'YYYY-MM-DD HH:mm:ss').valueOf()

            workingTime.planningsEstablishement?.forEach((h) => {
                console.log("[Calendar] Exception établissement :", h)

                if (h.status === -1) {
                    console.log("[Calendar] Exception établissement ignorée (status = -1) :", h)
                    return
                }
                this.c_selectedStaffs.forEach((x) => {
                    TimeSlotManager.addEstablishmentException(this.c_events, getDate(`${h.start}`), getDate(`${h.end}`), x.stringify)
                })
                this.c_selectedSpaces.forEach((x) => {
                    TimeSlotManager.addEstablishmentException(this.c_events, getDate(`${h.start}`), getDate(`${h.end}`), x.stringify)
                })
            })
        },
        getWeekDays() {
             const arr = []

            for (let i = 0; i < this.c_nbOfDay; i++) {
                const date = moment(this.c_dateFocus).add(i, "days")
                const week = date.week()

                const existing = arr.find(w => w.week === week)

                if (existing) {
                    existing.days.push(date.format("YYYY-MM-DD"))
                } else {
                    arr.push({
                        week: week,
                        days: [date.format("YYYY-MM-DD")]
                    })
                }
            }

            return arr
        },

        // _generateExceptionBlocs(workingTime) {
        //     const getDate = (str) => moment(str, 'YYYY-MM-DD HH:mm:ss').valueOf()

        //     workingTime.planningsEstablishement.forEach((h) => {
        //         console.log('h', h);
        //         // ⭐⭐ FIX : ignorer les ouvertures exceptionnelles ⭐⭐
        //         // nature_type == 2 = ouverture exceptionnelle → NE PAS BLOQUER
        //         if (h.status == -1) {
        //             // TU NE DOIS PAS AJOUTER DE BLOC
        //             return;
        //         }

        //         // ⭐ fermeture exceptionnelle, fermeture normale etc ⇒ OK
        //         this.c_selectedStaffs.forEach((x) => {
        //             TimeSlotManager.addEstablishmentException(
        //                 this.c_events,
        //                 getDate(`${h.start}`),
        //                 getDate(`${h.end}`),
        //                 x.stringify
        //             )
        //         })
        //         this.c_selectedSpaces.forEach((x) => {
        //             TimeSlotManager.addEstablishmentException(
        //                 this.c_events,
        //                 getDate(`${h.start}`),
        //                 getDate(`${h.end}`),
        //                 x.stringify
        //             )
        //         })
        //     })
        // },

        _generateMissingWorkingBlocs(days, done) {
            const getDate = (str) => moment(str, 'YYYY-MM-DD HH:mm:ss').valueOf()

            const hide = []
            days.forEach((d) => {
                this.c_selectedStaffs.forEach((s) => {
                    if (!done[d] || !done[d][s.id]) {
                        TimeSlotManager.addWorkingTime(
                            this.c_events,
                            getDate(`${moment(d * 1000).utc().format('YYYY-MM-DD')} 01:00:00`),
                            getDate(`${moment(d * 1000).utc().format('YYYY-MM-DD')} 23:00:00`),
                            this.c_staffs.find((x) => x.id == s.id).stringify
                        )
                        const target = hide.find((h) => h.id === s.id)
                        if (target) target.count -= 1
                        else hide.push({
                            id: s.id,
                            count: days.length - 1
                        })
                    }
                })
            })
            return hide
        },
        // == //

        // == Utils == //
        getTargetDays() {
            const targetsDays = []
            for (let i = 0; i < this.c_nbOfDay; i++)
                targetsDays.push(
                    moment
                        .utc(this.c_dateFocus)
                        .utcOffset(0)
                        .set({
                            hour: 0,
                            minute: 0,
                            second: 0,
                            millisecond: 0
                        })
                        .add(i, 'days')
                        .valueOf() / 1000
                )
            return targetsDays
        },

        // == Preset == //
        async applyPreset() {
            const target = this.c_presets.find((x) => x.name == this.c_selectedPresetName)
            if (!target) return
            // [staff]
            const newStaffs = []
            target.config.staffs.forEach((s) => {
                const wanted = this.c_staffs.find((x) => x.id === s)
                if (wanted) newStaffs.push(wanted)
                else console.warn(`[preset] - staff not found ${s}`)
            })
            // [space]
            const newSpaces = []
            target.config.spaces.forEach((s) => {
                const wanted = this.c_spaces.find((x) => x.id === s)
                if (wanted) newSpaces.push(wanted)
                else console.warn(`[preset] - space not found ${s}`)
            })
            // [Assign]
            this.c_selectedStaffs = newStaffs
            this.c_selectedSpaces = newSpaces
            this.c_nbOfDay = target.config.nbOfDay
            this.c_newLogin = target.config.newLogin
            this.c_slideValueY = target.config.slideValueY
            this.c_timeIntervalMinutes = parseInt(target.config.timeIntervalMinutes)
        },

        resetPreset() {
            // Aucun préréglage : le planning reste déployé avec tous les praticiens et toutes les salles.
            this.c_selectedStaffs = [...this.c_staffs]
            this.c_selectedSpaces = [...this.c_spaces]
            this.c_nbOfDay = 1
            this.c_newLogin = false
            this.c_slideValueY = 0
            this.c_timeIntervalMinutes = 30
        },

        async loadTargetedTimeslot() {
            await ApiManager.getTimeslotInfo(parseInt(this.c_query.timeslot)).then(async (res) => {
                const timeslot = await ApiManager.getAllTimeSlotOfBooking(res.booking.id)

                timeslot.forEach((t) => {
                    t.staff.forEach((s) => {
                        if (!this.c_selectedStaffs.find((x) => x.id == s.id)) {
                            const target = this.c_staffs.find((x) => x.id == s.id)
                            if (target) {
                                target.tmp = true
                                this.c_selectedStaffs.push(target)
                            }
                        }
                    })

                    if (!this.c_selectedSpaces.find((x) => x.id == t.timeslot[0].space.id)) {
                        const target = this.c_spaces.find((x) => x.id == t.timeslot[0].space.id)
                        if (target) {
                            target.tmp = true
                            this.c_selectedSpaces.push(target)
                        }
                    }
                })
                const event = this.c_events.find(x => x.id === `slot-${this.c_query.timeslot}`)
                if (event) {
                    this.c_selectedEvent = event;
                    this.c_showModal = true;
                }
            })
        },
    },
}
</script>

<style>
@import './_style/Calendar.css';
@import './_style/Modal.css';
</style>

<style lang="scss">
.v-event-timed {
    border-radius: 8px !important;
}

.v-event-timed.calendar-block-event,
.v-event-timed:has(.calendar-block-slot) {
    border-radius: 0 !important;
}

.v-calendar-category .v-calendar-daily__day {
    min-width: unset !important;
    flex: 1 1 auto !important;
    // max-width: 250px !important;
}

.v-calendar-category .v-calendar-category__columns .v-calendar-category__column-header {
    min-width: unset !important;
    flex: 1 1 auto !important;
    // max-width: 250px !important;
}

.v-calendar-daily__day-container .v-calendar-daily__day:nth-child(2) {
    .v-current-time {
        &.first::before {
            content: '';
            position: absolute;
            background-color: #ea4335;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            margin-top: -5px;
            margin-left: -6.5px;
            z-index: 10;
        }
    }
}

.v-current-time {
    height: 2px;
    background-color: #e23b2e;
    position: absolute;
    left: -1px;
    right: 0;
    pointer-events: none;
    z-index: 12;
}

.v-event-timed-container {
    margin-right: 0px !important;
}

.theme--light.v-calendar-events .v-event-timed {
    border: 1px solid #e4e4e4 !important;
}

.v-calendar-category .v-calendar-daily__head {
    z-index: 13 !important;
}

.v-calendar-staff {
    color: #111827;
    font-size: 13px;
    font-weight: 700;
}

.v-calendar-space {
    color: #111827;
    font-size: 13px;
    font-weight: 700;
}
.v-calendar-category .v-calendar-daily__day {
    min-width: unset !important;
    flex: 1 1 auto !important;
}

.v-calendar-category .v-calendar-category__columns .v-calendar-category__column-header {
    min-width: unset !important;
    flex: 1 1 auto !important;
}

/* Activer le scroll horizontal si nécessaire */
.horizontal-scroll {
    overflow-x: auto !important;
    overflow-y: hidden;
}

.v-calendar-daily__intervals-body {
    position: relative;
}

/* Assurer que les en-têtes restent alignés */
.v-calendar-daily__head {
    position: sticky;
    top: 0;
    z-index: 13 !important;
    background: white;
}
</style>
